import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { shape, arrayOf, string, oneOf, oneOfType, number } from 'prop-types';
import { TableTitle, TableContainer, Table, InnerTable, InnerTableLink, Name } from './table-factsheet.styles';

function TableFactsheet(_ref) {
  var _data$elements;

  let {
    data,
    layout
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["data", "layout"]);

  const subItemBuild = subItem => {
    return subItem.isLink ? /*#__PURE__*/React.createElement(InnerTableLink, {
      href: subItem.path
    }, subItem == null ? void 0 : subItem.value) : subItem == null ? void 0 : subItem.value;
  };

  return /*#__PURE__*/React.createElement(Table, props, /*#__PURE__*/React.createElement("tbody", null, data == null ? void 0 : (_data$elements = data.elements) == null ? void 0 : _data$elements.map(item => {
    var _item$elements;

    return /*#__PURE__*/React.createElement("tr", {
      key: item.slug
    }, /*#__PURE__*/React.createElement(TableTitle, {
      layout: layout
    }, item.keyName), /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(InnerTable, null, /*#__PURE__*/React.createElement("tbody", null, item == null ? void 0 : (_item$elements = item.elements) == null ? void 0 : _item$elements.map((subItem, idx) => /*#__PURE__*/React.createElement("tr", {
      key: idx
    }, subItem.keyName && /*#__PURE__*/React.createElement(Name, null, subItem.keyName), /*#__PURE__*/React.createElement("td", null, subItemBuild(subItem))))))));
  })));
}

process.env.NODE_ENV !== "production" ? TableFactsheet.propTypes = {
  color: string,
  fontSize: oneOfType([number, string]),
  layout: oneOf(['vertical', 'horizontal']),
  data: shape({
    elements: arrayOf(shape({
      keyName: string,
      value: string
    }))
  })
} : void 0;
TableFactsheet.defaultProps = {
  color: 'text.base',
  fontSize: 0,
  layout: 'vertical'
};
export default TableFactsheet;